import useMetaTags from "../../hooks/useMetaTags";
import {
  AssistanceSection,
  BenefitSection,
  FAQ,
  LargeData,
  roleWriting,
  CustomSection,
  sectionData
} from "../../Data/All_Services_Data/magentoDevelopmentServicesData";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";
import BulletsSection from "../../component/Services_Component/BulletsSection";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import FAQ_section from "../../component/Services_Component/FAQ_section";

const MagentoDevelopmentServices = () => {
    useMetaTags({
        title:
            "Magento Development Services Company | Warrgyizmorsch Solutions",
        description:
            "Warrgyizmorsch offers expert Magento development services to build powerful, scalable eCommerce stores that drive results. Custom solutions tailored to your business goals.",
        keywords:
            "Magento development services, magento web development company, magento development agency, magento development company, magento development, custom magento development, magento agency, magento web development, magento ecommerce development company, magento web developer, magento web design, magento ecommerce development, magento programming",
    });
    return (
        <>
            <section
                className=""
                style={{
                    backgroundImage: `url('assets/img/service/serviceD.jpg')`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
                id="service-sec"
            >
                <div className="round-container pt-5">
                    <div className="container">
                        <div className="title-area text-center">
                            <span className="sub-title text-white">OUR SERVICES</span>
                            <h1 className="sec-title text-white">
                                Magento Development Services
                            </h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="space-extra-bottom">
                <div className="page-single">
                    <div className="page-content">
                        <style>{`
                        .header-section{
                            display: flex;
                            align-items: center;
                            gap: 20px;
                            margin-bottom: 30px;
                        }
                        .header-section img{
                            height: 400px;
                        }
                        .header-section p{
                            text-align: left;
                        }

                        @media only screen and (max-width: 990px) {
                            .header-section{
                                flex-direction: column;
                            }
                            .header-section img{
                                height: 200px;
                            }
                            .header-section p{
                                text-align: center;
                            }
                        }
                    `}</style>
                        {/* Intro part  */}
                        <div
                            className="header-section container"
                            style={{ marginTop: "20px" }}
                        >
                            <img
                                src="assets/img/icon/magento-ecommerce-development.png"
                                loading="lazy"
                                alt="heading_image"
                            />
                            <div>
                                <p>
                                    At Warrgyizmorsch, you get Magento development services that are top-level and perfect for businesses needing reliable, scalable, and high-speed e-commerce platforms. Warrgyizmorsch, as a Magento web development company, supports you to make online stores that stay secure, attractive, and ready for more sales. From new shops for small companies to complex solutions for global brands, our Magento development agency brings you full and custom service. Certified Magento developers at Warrgyizmorsch work directly with you creating easy shopping using flexible back-end features. This team handles theme changes all the way to third-party integrations, making sure every option matches your business style. Because we focus on clean coding, strong extensions, and designs that work great on mobile, your store’s performance is better everywhere.  You might need custom Magento development, a fully-built eCommerce store, or just ongoing tweaks, no matter what, we use our knowledge and ideas for your project. At Warrgyizmorsch, we focus on intelligent solutions that increase your brand reach and also raise your revenue. 
                                </p>
                            </div>
                        </div>

                        <Benefits_section data={BenefitSection} />

                        <Custom_section data={CustomSection} />

                        <Handle_Largedata_section LargeData={LargeData} />

                        <BulletsSection data={sectionData} />

                        <Role_writing data={roleWriting} />

                        <Assistance_section data={AssistanceSection} />

                        <FAQ_section data={FAQ} />
                        
                    </div>
                </div>
            </section>
            <div className="scroll-top">
                <svg
                    className="progress-circle svg-content"
                    width="100%"
                    height="100%"
                    viewBox="-1 -1 102 102"
                >
                    <path
                        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                        style={{
                            transition: "stroke-dashoffset 10ms linear 0s",
                            strokeDasharray: "307.919, 307.919",
                            strokeDashoffset: "307.919",
                        }}
                    ></path>
                </svg>
            </div>
        </>
    )
}

export default MagentoDevelopmentServices